import React, { useState } from 'react';

import TemplateDropzone from './bulk/TemplateDropzone';
import GhostButton from './GhostButton';
import StepShell from './StepShell';
import useStepPayload from './useStepPayload';

/**
 * Upload your budget: the bulk budget template, mapped to the departments and
 * cost centres from the step before. A clean file is accepted and its lines
 * are added in the background, so the step turns complete once they land.
 */
export default function UploadStep({ step, urls, deferring, saving, onDefer, onNext, onStatusChange, onRefresh }) {
    const { data } = useStepPayload(urls.data, onStatusChange);
    const [queued, setQueued] = useState(false);

    const lede = $t('Bring in an existing budget using the InBudget template, mapped to the departments and cost centres you just created.');

    return (
        <StepShell step={step} lede={lede} deferring={deferring} saving={saving} onDefer={onDefer} onNext={onNext}>
            {!data ? (
                <p className="tw-text-sm tw-text-charcoal-50">{$t('Loading…')}</p>
            ) : (
                <div className="tw-flex tw-flex-col tw-gap-y-3.5">
                    {data.can_upload ? (
                        <>
                            <div>
                                <GhostButton as="a" href={urls.template}>
                                    {$t('Download the budget template')}
                                </GhostButton>
                            </div>
                            <TemplateDropzone
                                id="setup-wizard-upload-dropzone"
                                uploadUrl={urls.file}
                                fieldName="import_excel"
                                onUploaded={() => {
                                    setQueued(true);
                                    onRefresh();
                                }}
                            />
                        </>
                    ) : (
                        <p className="tw-text-sm tw-text-charcoal-75 tw-mb-0">{$t('You do not have permission to upload a budget.')}</p>
                    )}

                    {queued && (
                        <p role="status" className="tw-mb-0 tw-max-w-2xl tw-px-3.5 tw-py-2.5 tw-rounded-lg tw-bg-green-10 tw-text-sm tw-text-dark-green">
                            {$t(
                                'The file passed every check. Its budget lines are being added and will appear shortly; you will get an email when they are in.',
                            )}
                        </p>
                    )}

                    {data.has_lines && !queued && (
                        <p className="tw-mb-0 tw-text-sm tw-text-charcoal-75">{$t('This budget already has lines. Uploading adds more.')}</p>
                    )}
                </div>
            )}
        </StepShell>
    );
}
